import {
    Show,
    useRecordContext,
    TextField,
    ReferenceField,
    Pagination,
    Datagrid,
    ReferenceManyField,
    TopToolbar,
    RichTextField,
    SimpleShowLayout,
    DateField,
} from 'react-admin';

import { Test_Serieses } from '../../custom';
import ThumbnailField from '../../common/ThumbnailField';
import FullNameField from '../../common/FullNameField';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { LoadingSection } from '../../common/LoadingSection';
import AssignEcomProductModal from '../../common/ecom-products/AssignEcomProductModal';
import AssignedUserList from '../../common/ecom-products/AssignedUserList';
import { useAssignRefresh } from '../../hooks/useAssignRefresh';
import { useState } from 'react';
import { useParams } from 'react-router';
import { SoftDeleteWithDialogAction } from '../../common/SoftDeleteWithDialogAction';
import AssignedEcomProductList from '../../common/ecom-products/AssignedEcomProductList';

const StudentShowActions = ({ studentQuery, setStudentQuery }: any) => {
    return (
        <TopToolbar>
            <input
                className={'border rounded p-2 w-full mb-2'}
                value={studentQuery}
                onChange={e => setStudentQuery(e.target.value)}
                placeholder={'Search Student'}
            />
        </TopToolbar>
    );
};

const TestSeriesShow: any = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [studentQuery, setStudentQuery] = useState('');
    const { refreshKey, handleAssignSuccess } = useAssignRefresh();

    const handleTabClick = (index: any) => {
        setActiveTab(index);
    };
    let { id, mode } = useParams();
    if (!id) {
        return <LoadingSection />;
    }

    const tabData = [
        {
            label: 'Details',
            content: (
                <div>
                    <Show actions={<> </>} title={<Title />} resource={'test-series'} id={id}>
                        <SimpleShowLayout>
                            <ThumbnailField size={'large'} source="image" />
                            <TextField source="title" fullWidth />
                            <TextField source="type" fullWidth />
                            <ReferenceField reference={'programs'} source={'program_id'}>
                                <TextField fullWidth source="name" />
                            </ReferenceField>
                            <TextField source="status" />
                            <TextField source="textDescription" />
                            <RichTextField source="htmlDescription" />
                        </SimpleShowLayout>
                    </Show>
                </div>
            ),
        },

        {
            label: 'Product Details',
            content: (
                <Show actions={<></>} id={id} title={' '} resource={'test-series'}>
                    <SimpleShowLayout>
                        <AssignedEcomProductList type="test-series" typeId={id} refreshKey={refreshKey} />
                    </SimpleShowLayout>
                </Show>
            ),
        },
        {
            label: 'Students',
            content: (
                <div>
                    <AssignedUserList type="test-series" typeId={id} refreshKey={refreshKey} />
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="flex justify-end mx-10 gap-8 pt-5 pb-2">
                <AssignEcomProductModal
                    type="test-series"
                    typeId={id}
                    title="Assign Test Series"
                    onSuccess={handleAssignSuccess}
                />
            </div>
            <div className="rounded-md border">
                <div className="border-b py-2 flex text-lg flex-row gap-16 px-10 mb-6 rounded-t-md bg-white">
                    {tabData.map((tab, index) => (
                        <div
                            key={index}
                            onClick={() => handleTabClick(index)}
                            className={`hover:cursor-pointer ${
                                index === activeTab
                                    ? 'text-[#4f3cc9] underline decoration-4 underline-offset-[10px]'
                                    : ''
                            }`}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>

                <div className="tab-content bg-white px-2 pb-6">{tabData[activeTab].content}</div>
            </div>
        </>
    );
};

const Title = () => {
    const record = useRecordContext<Test_Serieses>();
    return record ? <span>{record.title}</span> : null;
};

export default TestSeriesShow;
